import React from "react";
import { Container } from "reactstrap";
import DefaultAvatarImg from "~/assets/images/profile/defaultAvatar.png";
import moment from 'moment';

const RecordsWinners = ({winners})=> {

  return (
    <div className="prev-winners">
    <h5 className="text-center"><strong>Records Breakers</strong></h5>
    <div className="players hide-scroll">
    { !winners.length ? <div className="info"><p>There are no winners. Check the guide to become one.</p></div> :
       winners.map((item, index)=>
        <div className="player" key={index}>

          <div className="avatar">
            <img src={ item.avatar || DefaultAvatarImg  } />
          </div>

          <div className="name">
            <p>{ item.firstName } {item.lastName}</p>
            <p>{ item.points } points</p>
          </div>

          <div className="position">
            {moment(item.createdAt).format("DD-MM-YYYY")}
          </div>
        </div>
      )}
    </div>

  </div>
  );
};

export default RecordsWinners;
